import React from "react";
import DashboardTitle from "../DashboardTitle/DashboardTitle";
import useStore from "../../../../../js/state/state";
import Notification from "./Notification/Notification";
import AlertSvg from "../../../Shared/Svgs/Alert";

const Notifications = () => {
    const { notifications } = useStore();

    return (
        <div className="Notifications">
            <DashboardTitle
                title="Notifications"
                svg={<AlertSvg />}
            />
            <div className="notificationsContainer">
                {notifications.map(
                    (notification, index) => (
                        <Notification
                            key={index}
                            {...notification}
                        />
                    )
                )}
            </div>
        </div>
    );
};

export default Notifications;
